module.exports = __webpack_public_path__ + "img/add-user-active.9699fe63.svg";